import produce from 'immer';
import {applyMiddleware, createStore} from "redux";
import thunk from "redux-thunk";

let store = null;

export const getStore = (props) => {
  if (!store) {
    store = createStore(
      reducer,
      props,
      // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
      applyMiddleware(thunk)
    );
  }
  return store;
};

export const reducer = produce((draft, action) => {
    switch (action.type) {
        case 'ADD_CART_ITEMS_QUANTITY':
            draft.cartItemsQuantity = action.payload.cartItemsQuantity
            return
        case 'REMOVE_CART_ITEMS_QUANTITY':
            draft.cartItemsQuantity -= action.payload.cartItemsQuantity
            return
        default:
            return;
    }
}, {});

export const addCartItemsQuantity = (cartItemsQuantity) => ({
    type: 'ADD_CART_ITEMS_QUANTITY',
    payload: {cartItemsQuantity}
});

export const removeCartItemsQuantity = (cartItemsQuantity) => ({
  type: 'REMOVE_CART_ITEMS_QUANTITY',
  payload: {cartItemsQuantity}
});